module.exports = __webpack_public_path__ + "img/cockroach_redchart02.ba1d62c5.jpg";